export default {
  title: 'Opening hours',
  headers: {
    edit_time: 'Edit time',
    create_time: 'Create time',
  },
  labels: {
    select_all: 'Select all',
    timezone: 'Timezone',
  },
  fields: {
    selected_days: {
      label: 'Selected days',
    },
    opening_time: {
      label: 'Opening time',
    },
    closing_time: {
      label: 'Closing time',
    },
  },
  columns: {
    days: 'Days',
    time: 'Time',
  },
  buttons: {
    add_opening_time: 'Add opening time',
    add: 'Add',
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    delete: 'Delete',
    sync_from_online_shop: 'Sync from Online Shop',
  },
  projects: {
    online_shop: 'Online Shop',
    reservations: 'Reservations',
    storefront: 'Storefront',
    not_set_up: '{{project}} (not set up for this location)',
  },
  feedback: {
    missing_info: 'Missing information',
  },
  toasts: {
    saving_success: 'Successfully saved',
    saving_error: 'Failed to save. Please review your information and try again.',
    sync_success: 'Successfully synced',
    sync_error: 'Failed to sync opening hours from online shop. Please try again.',
    hours_required: 'Opening hours are required. Edit existing hours instead',
    not_copied: {
      reservations: {
        not_set_up:
          "Reservations weren't updated: reservations aren't set up for this location yet. The Reservations tab explains why.",
        not_matched:
          "Reservations weren't updated: their hours don't include the opening time {{time}}. Check them in the Reservations tab.",
        failed: "Reservations couldn't be updated. Use “Sync from Online Shop” in the Reservations tab.",
      },
      storefront: {
        not_set_up: "The Storefront wasn't updated: no storefront was found for this location.",
        not_matched:
          "The Storefront wasn't updated: its hours don't include the opening time {{time}}. Check them in the Storefront tab.",
        failed: "The Storefront couldn't be updated. Use “Sync from Online Shop” in the Storefront tab.",
      },
    },
  },
  modals: {
    timezone: {
      form: {
        timezone: {
          label: 'Timezone',
        },
      },
      toasts: {
        error: 'Failed to update timezone',
      },
    },
  },
};
